import { useEffect, useState } from "react";
import { ROOT_ID } from "../utils/constants";

export const useDeviceDetector = (): { isMobile: boolean } => {
  const rootElement = document.getElementById(ROOT_ID);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    function handleResize() {
      setContainerWidth(
        document.documentElement.clientWidth || document.body.clientWidth
      );
    }

    window.addEventListener("resize", handleResize);
    handleResize();
  });

  const isMobile =
    rootElement?.dataset.preview === "mobile" || containerWidth <= 767;

  return { isMobile };
};
